<template>
  <a-table :scroll="{ x: 1600 }" :pagination="false" :columns="columns" size="middle" :data-source="issues" :loading="loading" row-key="id">
    <span slot="issueTitle" slot-scope="text, record">
      <a-tooltip placement="top" :title="record.title">
        <a class="custom-link" :href="issueLink(record)" target="_blank"> {{ record.title }} </a>
      </a-tooltip>
    </span>
    <span slot="tag" slot-scope="text, record">
      <a-popover placement="topLeft">
        <template slot="content">
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </template>
        <template slot="title">
          <span>缺陷标签</span>
        </template>
        <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
      </a-popover>
    </span>
    <span slot="priority" slot-scope="text, record">
      <a-tag v-if="record.priority" :color="issuePrioritys[record.priority].color"> {{ issuePrioritys[record.priority].label }} </a-tag>
      <span v-else>--</span>
    </span>
    <span slot="status" slot-scope="text, record">
      <a-tag :color="issueStatus[record.status].color"> {{ issueStatus[record.status].label }}</a-tag>
    </span>
    <span slot="type" slot-scope="text, record">
      {{ record.issue_type ? issueTypes[record.issue_type].label : '--' }}
    </span>
    <span slot="serious" slot-scope="text, record">
      {{ record.serious !== null ? issueSerious[record.serious].label : '--' }}
    </span>
    <span slot="handler" slot-scope="text, record">{{ getUser(record.handler) }}</span>
    <span slot="creator" slot-scope="text, record">{{ getUser(record.creator) }}</span>
    <span slot="verifier" slot-scope="text, record">{{ getUser(record.verifier) }}</span>
  </a-table>
</template>

<script>
import { issuePrioritys, issueTypes, issueSerious, issueStatus } from '@/utils/dictionary';

const columns = [
  {
    align: 'center',
    width: 30,
    fixed: 'left',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 110,
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '缺陷标题',
    width: 360,
    ellipsis: true,
    fixed: 'left',
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    title: '状态',
    width: 120,
    fixed: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '缺陷类型',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '优先级',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '缺陷等级',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'serious' }
  },
  {
    title: '处理人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'handler' }
  },
  {
    title: '验证人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'verifier' }
  },
  {
    title: '创建人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 180,
    align: 'center',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 180,
    align: 'center',
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];
export default {
  name: 'StoryIssueList',
  props: {
    issueList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      issuePrioritys,
      issueTypes,
      issueSerious,
      issueStatus,
      issues: []
      // loading: false
    };
  },
  computed: {
    issueLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id }
        });
        return route.href;
      };
    },
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  },
  watch: {
    issueList: {
      immediate: true,
      handler(val) {
        this.issues = val;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
